export default "__VITE_ASSET__CojKcqtU__"